import { classNamePrefix } from '../globals';
import { TChoices } from '../types';
import { capitalize } from '../utils';
import { renderCheckbox } from './checkbox';
import { renderDescription } from './description';
import { renderImage } from './image';
import { renderLink } from './link';

export function renderService (
    name: string,
    label: string,
    description: string,
    privacyPolicy: string,
    required: boolean,
    getChoices: () => TChoices,
    url?: string,
    imageSource?: string
) {
    const className = classNamePrefix + '-service';
    const checkboxId = classNamePrefix + '-service-checkbox-' + name;

    const choices = getChoices() as TChoices;

    // Service
    const serviceElement = document.createElement('div');
    serviceElement.classList.add(className);
    serviceElement.dataset.serviceName = name;

    // Checkbox
    const checkboxElement = renderCheckbox(checkboxId, name, className + '__checkbox');
    const hiddenCheckboxElement = checkboxElement.querySelector('input') as HTMLInputElement;

    if (choices[name]) {
        hiddenCheckboxElement.checked = true;
    }

    if (required) {
        hiddenCheckboxElement.disabled = true;
    }

    serviceElement.appendChild(checkboxElement);

    // Content
    const contentElement = document.createElement('div');
    contentElement.classList.add(className + '__content');

    // Label container
    const labelContainerElement = document.createElement('div');
    labelContainerElement.classList.add(className + '__label-container');

    contentElement.appendChild(labelContainerElement);

    // Label
    const labelElement = document.createElement('label');
    labelElement.classList.add(className + '__label');
    labelElement.setAttribute('for', checkboxId);
    labelElement.innerText = label;

    labelContainerElement.appendChild(labelElement);

    // Image
    if (imageSource) {
        const imageElement = renderImage(
            imageSource,
            '',
            '100%',
            undefined,
            undefined,
            className + '__image'
        );

        labelContainerElement.appendChild(imageElement);
    }

    // Description
    const descriptionElement = renderDescription(description);
    contentElement.appendChild(descriptionElement);

    // Link
    if (url) {
        const linkElement = renderLink(url, `${privacyPolicy} ${capitalize(name)}`, '_blank');
        contentElement.appendChild(linkElement);
    }

    serviceElement.appendChild(contentElement);

    return serviceElement;
}